import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mockData';
import { Card, CardContent } from './ui/card';

const cardGradients = [
  'from-cyan-50 to-blue-50',
  'from-purple-50 to-pink-50',
  'from-blue-50 to-indigo-50',
  'from-teal-50 to-emerald-50'
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-purple-200/30 to-pink-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tr from-cyan-200/30 to-blue-200/30 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <span className="text-transparent bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text font-bold text-sm uppercase tracking-wider">Patient Reviews</span>
          <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-900 via-purple-800 to-pink-900 bg-clip-text text-transparent mt-2">What Patients Say</h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-lg">
            Real experiences from patients who trust Dr. Mitchell with their healthcare
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={testimonial.id} className={`border-2 border-purple-200 shadow-xl hover:shadow-2xl transition-all duration-300 relative group hover:-translate-y-2 bg-gradient-to-br ${cardGradients[index]}`}>
              <CardContent className="p-8">
                <div className="absolute -top-4 -left-4 bg-gradient-to-br from-purple-500 to-pink-500 p-4 rounded-xl shadow-lg transform group-hover:rotate-12 transition-transform duration-300">
                  <Quote className="h-8 w-8 text-white" />
                </div>
                
                {/* Rating */}
                <div className="flex space-x-1 mb-4 mt-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-6 w-6 text-yellow-400 fill-yellow-400 animate-pulse" style={{ animationDelay: `${i * 100}ms` }} />
                  ))}
                </div>

                {/* Review text */}
                <p className="text-gray-800 text-lg mb-6 leading-relaxed font-medium">
                  {testimonial.text}
                </p>

                {/* Author */}
                <div className="flex items-center justify-between border-t-2 border-purple-200 pt-4">
                  <div>
                    <div className="font-bold text-gray-900 text-lg">{testimonial.name}</div>
                    <div className="text-sm text-purple-600 font-medium">{testimonial.date}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;